import { resultFromFieldSelector } from '../search/search-selectors.js';
export function answerSourceSelector(state, documentIdentifier) {
    const documentId = documentIdentifier ?? state.search?.questionAnswer?.documentId;
    return (documentId &&
        state.search &&
        resultFromFieldSelector(state, documentId.contentIdKey, documentId.contentIdValue));
}
export function relatedQuestionSelector(state, questionAnswerId) {
    const index = state.questionAnswering?.relatedQuestions.findIndex((relatedQuestion) => relatedQuestion.questionAnswerId === questionAnswerId) ?? -1;
    if (index === -1) {
        return null;
    }
    const searchQuestionState = state.search?.questionAnswer?.relatedQuestions?.[index];
    return searchQuestionState ?? null;
}
